import { render, staticRenderFns } from "./ModalEditProduct.vue?vue&type=template&id=04425b54"
import script from "./ModalEditProduct.vue?vue&type=script&lang=js"
export * from "./ModalEditProduct.vue?vue&type=script&lang=js"
import style0 from "./ModalEditProduct.vue?vue&type=style&index=0&id=04425b54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports